/**
 * Copyright (C) 2020 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */

import React, { useCallback } from 'react';
import Label from '@mui/icons-material/Label';

import { StyledToggleButtonGroup, StyledToggleButton, ToggleGroupContainer } from '../toggle_group/ToggleButton';
import { TailTagSize } from '../../../store/maps/reducer';
import { PanelLabel } from './PanelLabel';

interface TailTagSizeControllerProps {
  terminalTagSize: TailTagSize;
  setTerminalTagsSize: Function;
}

export function TailTagSizeController({ terminalTagSize, setTerminalTagsSize }: TailTagSizeControllerProps) {
  const handleSelectionChange = useCallback(
    (event: React.MouseEvent<HTMLElement>, newValue: TailTagSize) => {
      if (newValue !== null) {
        setTerminalTagsSize(newValue);
      }
    },
    [setTerminalTagsSize],
  );

  return (
    <ToggleGroupContainer>
      <PanelLabel>TAIL TAG SIZE</PanelLabel>

      <StyledToggleButtonGroup exclusive value={terminalTagSize} onChange={handleSelectionChange}>
        <StyledToggleButton
          data-test="tail-tag-size-button-small"
          value={TailTagSize.SMALL}
          disableRipple
          disableFocusRipple
          style={{ top: 25, left: 17 }}
        >
          <Label style={{ width: 14, height: 14 }} />
        </StyledToggleButton>
        <StyledToggleButton
          data-test="tail-tag-size-button-large"
          value={TailTagSize.LARGE}
          disableRipple
          disableFocusRipple
          style={{ top: 23, left: 52 }}
        >
          <Label style={{ width: 20, height: 20 }} />
        </StyledToggleButton>
      </StyledToggleButtonGroup>
    </ToggleGroupContainer>
  );
}

export default TailTagSizeController;
